import { render } from "./SelectVerseList.vue?vue&type=template&id=7563317f&ts=true"
import script from "./SelectVerseList.vue?vue&type=script&lang=ts"
export * from "./SelectVerseList.vue?vue&type=script&lang=ts"

import "./SelectVerseList.vue?vue&type=style&index=0&id=7563317f&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__